import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _d730c518 = () => interopDefault(import('../pages/docSearch.vue' /* webpackChunkName: "pages/docSearch" */))
const _7bf24701 = () => interopDefault(import('../pages/test.js' /* webpackChunkName: "pages/test" */))
const _514e0dac = () => interopDefault(import('../pages/demoList/service.js' /* webpackChunkName: "pages/demoList/service" */))
const _2a7daf10 = () => interopDefault(import('../pages/webDemoCenter/_.vue' /* webpackChunkName: "pages/webDemoCenter/_" */))
const _053b13f6 = () => interopDefault(import('../pages/sdkDemoCenter/_.vue' /* webpackChunkName: "pages/sdkDemoCenter/_" */))
const _78f6e0df = () => interopDefault(import('../pages/news/_.vue' /* webpackChunkName: "pages/news/_" */))
const _de5c2aa6 = () => interopDefault(import('../pages/demoList/_.vue' /* webpackChunkName: "pages/demoList/_" */))
const _2237355a = () => interopDefault(import('../pages/_.vue' /* webpackChunkName: "pages/_" */))

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: decodeURI('/'),
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/docSearch",
    component: _d730c518,
    name: "docSearch"
  }, {
    path: "/test",
    component: _7bf24701,
    name: "test"
  }, {
    path: "/demoList/service",
    component: _514e0dac,
    name: "demoList-service"
  }, {
    path: "/webDemoCenter/*",
    component: _2a7daf10,
    name: "webDemoCenter-all"
  }, {
    path: "/sdkDemoCenter/*",
    component: _053b13f6,
    name: "sdkDemoCenter-all"
  }, {
    path: "/news/*",
    component: _78f6e0df,
    name: "news-all"
  }, {
    path: "/demoList/*",
    component: _de5c2aa6,
    name: "demoList-all"
  }, {
    path: "/*",
    component: _2237355a,
    name: "all"
  }],

  fallback: false
}

export function createRouter () {
  return new Router(routerOptions)
}
